module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-4-m2.dddf6cfd.jpg";